import { render, staticRenderFns } from "./CreateCategories.vue?vue&type=template&id=cce5d56a&scoped=true"
import script from "./CreateCategories.vue?vue&type=script&lang=js"
export * from "./CreateCategories.vue?vue&type=script&lang=js"
import style0 from "./CreateCategories.vue?vue&type=style&index=0&id=cce5d56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce5d56a",
  null
  
)

export default component.exports